(ns ycweb.app.dashboard.newsletter.constraints
  (:require
   [ycweb.util.core :as u]
   [util.string :as str]
   [rum.core :as rum]
   [ycweb.components.forms :as forms]
   #?@(:clj
       [[db.all :as db]
        [datomic.api :as d]
        [macaron.datomic :as md]
        [macaron.mysql :as mysql]
        [util.core :as uc]])
   [ycweb.components.common :as cmn]
   [clojure.set :as set]
   [util.transform :as trf]))

(def query-staff-members
  #?(:clj
     (mysql/prepare-query
       "SELECT SQL_NO_CACHE gl.userid
        FROM groups g
          INNER JOIN grouplink gl ON (g.id = gl.groupid)
        WHERE g.name IN ('SiteAdmin', 'Admin', 'Staff');")
     :cljs (fn [& _] [])))

(def staff-constraint
  {:constrainttype "staff"
   :title "Staff"
   :text-fn (fn [& _] "Yuppiechef Staff")
   :memberset-fn
   (fn [{:keys [ycdb]} constraint]
     (->>
       (query-staff-members ycdb)
       (map :userid)
       (set)))})

(def query-trade-clients
  #?(:clj
     (mysql/prepare-query
       {:paramset #{}
        :qry
        "SELECT SQL_NO_CACHE gl.userid
         FROM groups g
           INNER JOIN grouplink gl ON (g.id = gl.groupid)
         WHERE g.fullname LIKE 'Clients:Trade%';"})
     :cljs (fn [& _] [])))

(def trade-client-constraint
  {:constrainttype "trade"
   :title "Trade"
   :text-fn (fn [& _] "Trade Clients")
   :memberset-fn
   (fn [{:keys [ycdb]} constraint]
     (->>
       (query-trade-clients ycdb)
       (map :userid)
       (set)))})

(def query-member-email
  #?(:clj
     (mysql/prepare-query
       "SELECT u.id userid
        FROM users u
        WHERE u.email IN (:emails)")
     :cljs (fn [& _] [])))

(rum/defc email-form < rum/reactive [app-atom constraint-atom]
  (let [{:keys [properties]} (rum/react constraint-atom)]
    (list

      (map-indexed
        (fn [idx e]
          [:div
           {:key (str "email" idx)
            :class (u/bem :flex-grid-group [:align-left :valign-middle :fluid :flush-force :flush])}
           [:div
            {:class (u/bem :flex-grid-block [:grow-yes :fluid])}
            [:div.flex-grid-content
             (forms/input-raw "joe@example.com" (rum/cursor-in constraint-atom [:properties :emails idx]) {})]]
           [:div
            {:class (u/bem :flex-grid-block [:fluid])}
            [:div.flex-grid-content
             [:button.raw-button.icon-link
              {:class (u/bem :icon-block-link [:size-small])
               :on-click
               (fn []
                 (swap! constraint-atom update-in [:properties :emails]
                   #(u/remove-vec % idx)))}
              [:i {:class (u/bem :icon [:is-dark :delete :block])}]
              [:span.u-hidden-from-view "Remove this email"]]]]])
        (:emails properties))

      [:footer.admin-options-board__footer
       [:button
        {:class (u/bem :button [:dark])
         :on-click #(swap! constraint-atom update-in [:properties :emails] conj "")}
        "Add email"]])))

(def emaillist-constraint
  {:constrainttype "emaillist"
   :title "Specific Email List"
   :form #'email-form
   :default-properties {:emails [""]}
   :text-fn
   (fn [constraint]
     (let [emails (:emails (:properties constraint))
           c (if (u/presence emails) (count emails) 0)]
       (str
         c " specific email " (if (== 1 c) "address" "addresses"))))
   :memberset-fn
   (fn [{:keys [ycdb]} constraint]
     (->>
       (query-member-email ycdb {:emails (get-in constraint [:properties :emails])})
       (map :userid)
       (set)))})

(def query-interests
  #?(:clj
     (mysql/prepare-query
       "SELECT i.user_id
        FROM newsletter_user_interest i
          INNER JOIN newsletter_list_member m ON (m.user_id = i.user_id)
        WHERE interest_id IN (:interest_ids)
          AND i.status = 'subscribed'
          AND m.status = 'subscribed';")
     :cljs (fn [& _] [])))

(defn interest-data [{:keys [ycdb]}]
  #?(:clj
     (let [newsletterlist (mysql/find-by ycdb db/newsletter_list :label "yc")]
       (mysql/list-all ycdb db/newsletter_interest :list_id (:id newsletterlist)))))

(rum/defc interest-form < rum/reactive [app-atom constraint-atom]
  (let [constraint-data (cmn/curact app-atom [:newsletter :constraints "interests"])]
    (into
      [:div]
      (map
        (fn [c]
          [:div
           (forms/checkbox
             ;; TODO: The subscriber_count is wildly off - should probably make a cron to update them.
             [:span (:displaylabel c) #_[:small " (" (:subscriber_count c) ")"]]
             (rum/cursor-in constraint-atom [:properties :interest-ids (:id c)]))])
        constraint-data))))

(def interest-constraint
  {:constrainttype "interests"
   :title "Interests"
   :form #'interest-form
   :data #'interest-data
   :default-properties
   {:interest-names #{} :interest-ids {}}

   :text-fn
   (fn [constraint]
     (str "with any of these interests: " (str/join "," (sort (get-in constraint [:properties :interest-names])))))

   :memberset-fn
   (fn [{:keys [ycdb]} constraint]
     (->>
       (query-interests ycdb
         {:interest_ids
          (->>
            (get-in constraint [:properties :interest-ids])
            (filter (fn [[id included?]] included?))
            (map first))})
       (map :user_id)
       (set)))})

(rum/defc limit-form < rum/reactive [app-atom constraint-atom]
  [:div
   (forms/input
     "Send Limit:"
     "Limit count"
     (rum/cursor-in constraint-atom [:properties :count])
     {:required? true :type :number})])

(def limit-constraint
  {:constrainttype "limit"
   :title "Audience limit"
   :form #'limit-form
   :default-properties {:count 50000}
   :text-fn
   (fn [constraint]
     (str "limit to " (u/number-format (get-in constraint [:properties :count])) " emails"))
   :memberset-postfn
   (fn [ctx constraint memberset]
     (set (take (get-in constraint [:properties :count]) memberset)))})

;; -------------------------------------------------------------------------

(def successful-order-statuses
  #?(:clj
     (seq
       (map #(mysql/convert-integrate-column db/ecommerce_orders :status %)
         ["Paid" "Sent to Courier" "Delivered" "Followed Up" "Please Contact" "Ready to Ship"]))))

(def query-users-by-paymenttypes
  #?(:clj
     (mysql/prepare-query
       "SELECT eo.userid
        FROM ecommerce_payments as ep
          INNER JOIN ecommerce_orders eo ON (ep.orderid = eo.id)
        WHERE ep.paymenttype IN (:paymenttypes)
          AND ep.amount > 0
          AND eo.status IN (:statuses)
          AND userid != 2
        GROUP BY eo.userid")))

(def payment-type-lookup
  {"Credit Card"
   ["Credit Card" "Shop:Thumbzup" "Shop:Card" "Saved Credit Card" "Shop:Yoco" "visacheckout" "CreditCard" "Credit" "CCard Machine" "CCard" "Credit From" "Amex"]
   "eBucks"
   ["eBucks" "eBucks New" "eBucks API" "eBucks Transfer" "Shop:eBucks"]
   "Transfer"
   ["Transfer"]
   "Cash"
   ["Cash" "Shop:Cash"]
   "Discovery Miles"
   ["Discovery"]
   "SnapScan"
   ["SnapScan" "Shop:Snapscan"]
   "Zapper"
   ["Zapper" "Shop:Zapper"]})

(defn paymenttypes-data [{:keys [ycdb]}]
  (sort String/CASE_INSENSITIVE_ORDER (keys payment-type-lookup)))

(rum/defc paymenttype-form < rum/reactive [app-atom constraint-atom]
  (let [constraint-data (cmn/curact app-atom [:newsletter :constraints "paymenttypes"])]
    (into
      [:div]
      (map
        (fn [c]
          [:div
           (forms/checkbox
             [:span c]
             (rum/cursor-in constraint-atom [:properties :paymenttype-ids c]))])
        constraint-data))))

(def paymenttype-constraint
  {:constrainttype "paymenttypes"
   :title "Payment Types"
   :form #'paymenttype-form
   :data #'paymenttypes-data
   :default-properties
   {:paymenttype-names #{} :paymenttype-ids {}}

   :text-fn
   (fn [constraint]
     (let [payment-types (keys (get-in constraint [:properties :paymenttype-ids]))]
       (str "with any of these payment types: " (str/join "," (sort payment-types)))))

   :memberset-fn
   (fn [{:keys [ycdb]} constraint]
     (let [parameters
           {:statuses successful-order-statuses
            :paymenttypes
            (->>
              (get-in constraint [:properties :paymenttype-ids])
              (filter (fn [[id included?]] included?))
              (reduce
                (fn [acc [payment-type _]]
                  (cond
                    (get payment-type-lookup payment-type)
                    (concat acc (get payment-type-lookup payment-type))

                    :else
                    acc))
                []))}]
       (->>
         (query-users-by-paymenttypes ycdb parameters)
         (map :userid)
         (set))))})

;; -------------------------------------------------------------------------

(defn calculate-distance [point1 point2]
  ;;Based off of: https://www.movable-type.co.uk/scripts/latlong.html
  (let [r 6371e3
        radian (/ Math/PI 180)
        phi-1 (* (:lat point1) radian)
        phi-2 (* (:lat point2) radian)
        delta-phi (* (- (:lat point2) (:lat point1)) radian)
        delta-lambda (* (- (:long point2) (:long point1)) radian)

        a (+
            (* (Math/sin (/ delta-phi 2)) (Math/sin (/ delta-phi 2)))
            (*
              (Math/cos phi-1) (Math/cos phi-2)
              (Math/sin (/ delta-lambda 2)) (Math/sin (/ delta-lambda 2))))

        c (* 2 (Math/atan2 (Math/sqrt a) (Math/sqrt (- 1 a))))

        d (* r c)]
    d))

(defn location-data [{:keys [ycdb]}]
  #?(:clj
     (mysql/list-all ycdb db/store)))

(rum/defc location-form < rum/reactive [app-atom constraint-atom]
  (let [newsletter-atom (rum/cursor app-atom :newsletter)
        constraint-data (cmn/curact newsletter-atom [:constraints "location"])
        idx-c-data (u/index-by :id constraint-data)]
    [:div
     {:class (u/bem :flex-grid-group [:flush])
      :style {:max-height "100%" :max-width "100%"}}
     [:div
      {:class (u/bem :flex-grid-block [:align-left :l-1-1])
       :style {:padding "0px"}}
      ;;Right container
      [:div
       {:class (u/bem :flex-grid-block [:align-left :l-1-2])}
       [:div
        {:style {:width "100%"}}
        (forms/select
          "Select a store for coordinates or provide your own:"
          (rum/cursor-in newsletter-atom [:constraints :store])
          (->>
            constraint-data
            (map
              (fn [d]
                {:value (:id d) :text (:name d)}))
            (sort-by :text)
            (concat
              [{:value 0 :text "Please select a store or enter coordinates manually"}]))
          {:change-fn
           (fn [e v]
             (let [selected-id (trf/tonumber v)
                   selected-constraint (get idx-c-data selected-id)]
               (swap! constraint-atom update-in [:properties :coordinates] assoc
                 :lat (or (:latitude selected-constraint) 0)
                 :long (or (:longitude selected-constraint) 0))))})]]
      ;;Left container
      [:div
       {:class (u/bem :flex-grid-block [:align-left :l-1-2])}
       [:div
        {:class :flex-grid-group
         :style {:width "100%"}}
        [:div
         {:class (u/bem :flex-grid-block [:align-left :l-1-3])}
         (forms/input "Distance (Km):" ""
           (rum/cursor-in constraint-atom [:properties :coordinates :distance])
           {:default 0})]
        [:div
         {:class (u/bem :flex-grid-block [:align-left :l-1-3])}
         (forms/input "Latitude:" "" (rum/cursor-in constraint-atom [:properties :coordinates :lat]))]
        [:div
         {:class (u/bem :flex-grid-block [:align-left :l-1-3])}
         (forms/input "Longitude:" "" (rum/cursor-in constraint-atom [:properties :coordinates :long]))]]]]

     ;;Warning
     [:div
      {:class (u/bem :flex-grid-block [:align-left :l-1-1])
       :style {:padding "0px"}}
      [:div.feedback.feedback--warning
       [:div.feedback__icon
        [:i.icon.icon--warning.icon--is-dark.icon--default.icon--inline]]
       [:div.feedback__message
        [:h4.feedback-title "Audience logic"]
        [:p.feedback-description
         "Fetches users linked to ANY of their delivery addresses that are matched on postcodes,
         within X amount of kilometers of the latitude and longitude coordinates provided."
         [:br]
         [:small "This excludes deliveries linked to gift orders"]
         [:br]
         [:small "May include users that reside outside of the targeted area but purchase items for someone living in the targeted area :'("]]]]]]))

(defn attach-postcode-distance [coords {:geo/keys [latitude longitude] :postal-area/keys [code] :as existing-postcode}]
  (let [distance (calculate-distance coords {:lat latitude :long longitude})]
    (assoc existing-postcode :postal-area/distance (u/round (/ distance 1000) 2))))

(defn postcodes-by-lat-long [datomic coords]
  #?(:clj
     (->>
       (d/q
         '[:find [(pull ?e [:postal-area/code :geo/latitude :geo/longitude]) ...]
           :where
           [?e :postal-area/code ?postcodes]]
         (md/db datomic))
       (map (partial attach-postcode-distance coords))
       (filter #(< (:postal-area/distance %) (:distance coords)))
       (map :postal-area/code))))

(def query-users-by-delivery-postcodes
  #?(:clj
     (mysql/prepare-query
       "SELECT eo.userid
        FROM ecommerce_orders eo
          INNER JOIN ecommerce_delivery ed ON (eo.id = ed.orderid)
          INNER JOIN ecommerce_delivery_options edo ON (ed.deliveryoptionid = edo.id)
          INNER JOIN ecommerce_delivery_companies edc on (edc.id = ed.deliverycompanyid)
        WHERE ed.receiverpostalcode IN (:postcodes)
          AND edo.code NOT IN ('HAND', 'COL')
          AND edc.name IN ('Aramex', 'RAM')
          AND eo.isgift = FALSE
          AND ed.dateadded >= UNIX_TIMESTAMP(DATE_SUB(CURDATE(), INTERVAL 12 MONTH))
        GROUP BY eo.userid")))

(def location-constraint
  {:constrainttype "location"
   :title "Location"
   :form #'location-form
   :data #'location-data
   :default-properties
   {:location-names #{} :coordinates {}}

   :text-fn
   (fn [constraint]
     (let [coords (get-in constraint [:properties :coordinates])]
       (str "within " (:distance coords) "Km of latitude: " (:lat coords) " & longitude: " (:long coords))))

   :memberset-fn
   (fn [{:keys [ycdb datomic]} constraint]
     (let [coordinates (get-in constraint [:properties :coordinates])
           coords
           {:distance (trf/tonumber (:distance coordinates))
            :lat (trf/tonumber (:lat coordinates))
            :long (trf/tonumber (:long coordinates))}
           nearby-postcodes (postcodes-by-lat-long datomic coords)]
       (->>
         (query-users-by-delivery-postcodes ycdb {:postcodes nearby-postcodes})
         (map :userid)
         (set))))})

;; -----------------------------------------------------------------------------------------------------------------
;; PURCHASE HISTORY CONSTRAINT
;; -----------------------------------------------------------------------------------------------------------------

(rum/defc purchase-history-form < rum/reactive [app-atom constraint-atom]
  [:div
   {:style {:max-height "100%" :max-width "100%"}}
   [:div
    [:div.u-margin-bottom-10
     {:style {:width "100%"}}
     (forms/radio
       [:div
        [:div "Store Only"]
        [:span
         {:class
          (u/bem :yc-list [:small-force])}
         "Users who have only made purchases in one of our stores (not online)"]]
       "STORE_ONLY"
       (rum/cursor-in constraint-atom [:properties :purchase_category]))]
    [:div.u-margin-bottom-10
     {:style {:width "100%"}}
     (forms/radio
       [:div
        [:div "Online Only"]
        [:span
         {:class
          (u/bem :yc-list [:small-force])}
         "Users who have only purchased from us online (not in any store)"]] "ONLINE_ONLY"
       (rum/cursor-in constraint-atom [:properties :purchase_category]))]
    [:div.u-margin-bottom-10
     {:style {:width "100%"}}
     (forms/radio
       [:div
        [:div "No Purchases"]
        [:span
         {:class
          (u/bem :yc-list [:small-force])}
         "Users who have not made any successful purchases (online or in store)"]] "NONE"
       (rum/cursor-in constraint-atom [:properties :purchase_category]))]]])

(def query-users-no-purchase-history
  #?(:clj
     (mysql/prepare-query
       "SELECT uc.userid
        FROM users_cache uc
        WHERE uc.totalorders = 0")))

(def query-users-store-only-purchase-history
  #?(:clj
     (mysql/prepare-query
       "SELECT uc.userid
        FROM users_cache uc
        WHERE totalorders_store > 0
          AND totalorders_online = 0")))

(def query-users-online-only-purchase-history
  #?(:clj
     (mysql/prepare-query
       "SELECT uc.userid
        FROM users_cache uc
        WHERE totalorders_online > 0
          AND totalorders_store = 0")))

(def purchase-history-constraint
  {:constrainttype "purchase-history"
   :title "Purchase History"
   :form #'purchase-history-form

   :text-fn
   (fn [constraint]
     (let [purchase-category (get-in constraint [:properties :purchase_category])]
       (case purchase-category
         "STORE_ONLY" "Only purchases made in store"
         "ONLINE_ONLY" "Only purchases made online"
         "NONE" "No purchases made with YC")))

   :memberset-fn
   (fn [{:keys [ycdb]} constraint]
     (let [purchase-category (get-in constraint [:properties :purchase_category])
           query-results
           (case purchase-category
             "STORE_ONLY" (query-users-store-only-purchase-history ycdb)
             "ONLINE_ONLY" (query-users-online-only-purchase-history ycdb)
             "NONE" (query-users-no-purchase-history ycdb))]
       (->>
         query-results
         (map :userid)
         (set))))})

;; -----------------------------------------------------------------------------------------------------------------
;; STORE CONSTRAINT
;; -----------------------------------------------------------------------------------------------------------------

(def query-stores
  #?(:clj
     (mysql/prepare-query
       "SELECT eo.userid
        FROM ecommerce_orders eo
          INNER JOIN ecommerce_order_storelink eos ON (eos.order_id = eo.id AND linktype = 'Placed')
        AND store_id IN (:store_ids) AND eo.status IN (2, 3, 4, 6, 10, 11)
        GROUP BY eo.userid")
     :cljs (fn [& _] [])))

(defn store-data [{:keys [ycdb]}]
  #?(:clj
     (mysql/list-all ycdb db/store)))

(rum/defc store-form < rum/reactive [app-atom constraint-atom]
  (let [constraint-data (cmn/curact app-atom [:newsletter :constraints "stores"])]
    (into
      [:div]
      (map
        (fn [c]
          [:div
           (forms/checkbox
             [:span (:name c)]
             (rum/cursor-in constraint-atom [:properties :store-ids (:id c)]))])
        constraint-data))))

(def store-constraint
  {:constrainttype "stores"
   :title "Stores"
   :form #'store-form
   :data #'store-data
   :default-properties
   {:store-names #{} :store-ids {}}

   :text-fn
   (fn [constraint]
     (let [store-ids (keys (filter (comp true? second) (get-in constraint [:properties :store-ids])))]
       (str "with any of these stores: "
         (str/join ","
           (sort store-ids)))))

   :memberset-fn
   (fn [{:keys [ycdb]} constraint]
     (->>
       (query-stores ycdb
         {:store_ids
          (->>
            (get-in constraint [:properties :store-ids])
            (filter (fn [[id included?]] included?))
            (map first))})
       (map :userid)
       (set)))})

(def constraintdefs
  (->>
    [emaillist-constraint
     staff-constraint
     trade-client-constraint
     interest-constraint
     limit-constraint
     paymenttype-constraint
     location-constraint
     purchase-history-constraint
     store-constraint]
    (map (fn [c] [(:constrainttype c) c]))
    (into {})))

(defn generate-segment-description [constraints]
  (let [texts
        (->>
          constraints
          (map
            (fn [c]
              (let [{:keys [text-fn]} (get constraintdefs (:constrainttype c))]
                (when text-fn
                  (text-fn c)))))
          (remove nil?))

        initial-texts
        (->>
          (butlast texts)
          (str/join ", "))]

    (u/glue " and " initial-texts (last texts))))

(defn constraints-data [ctx]
  (->>
    constraintdefs
    (map
      (fn [[ctype c]]
        (let [data-fn (:data c)
              data (when data-fn (data-fn ctx))]
          (when data
            [ctype data]))))
    (remove nil?)
    (into {})))

(def query-unsubscribers
  #?(:clj
     (mysql/prepare-query
       "SELECT userid FROM unsubscribers WHERE userid IN (:userids)")

     :cljs
     (fn [& _])))

(def query-excluded-contacts
  #?(:clj
     (mysql/prepare-query
       "SELECT user_id
        FROM temp_campaign_contact_exclusion
        WHERE campaign_id = :campaign-id
          AND user_id IN (:userids)")

     :cljs
     (fn [& _])))

(defn remove-unsubscribed [{:keys [ycdb]} userid-set]
  (let [unsubscribers
        (->>
          (query-unsubscribers ycdb {:userids userid-set})
          (map :userid)
          set)]
    (set/difference userid-set unsubscribers)))

(defn remove-excluded-contacts [{:keys [ycdb]} campaign userid-set]
  (let [excluded-contacts
        (->>
          (query-excluded-contacts ycdb {:userids userid-set :campaign-id (:id campaign)})
          (map :user_id)
          set)]
    (set/difference userid-set excluded-contacts)))

(def query-campaign-sent
  #?(:clj
     (mysql/prepare-query
       "SELECT user_id FROM mailrecord WHERE campaign_id = :campaignid")
     :cljs
     (fn [& _])))

(defn remove-sent [{:keys [ycdb]} campaign userid-set]
  (let [campaign-users
        (->>
          (query-campaign-sent ycdb {:campaignid (:id campaign)})
          (map :user_id)
          set)]
    (set/difference userid-set campaign-users)))

(defn constraint-user-ids [ctx constraints]
  (->>
    constraints
    (map
      #(let [{:keys [memberset-fn]} (get constraintdefs (:constrainttype %))]
         (when memberset-fn
           (memberset-fn ctx %))))
    (remove nil?)
    (set)))

(defn segmentuserids [ctx campaign constraints]
  (let [[exclude-userid-sets include-userid-sets]
        (map
          (partial constraint-user-ids ctx)
          (u/separate #(get-in % [:properties :exclude?]) constraints))

        userid-set
        (->>
          (if (empty? include-userid-sets)
            #{}
            (set/difference
              (apply set/intersection include-userid-sets)
              (apply set/union exclude-userid-sets)))
          (remove-unsubscribed ctx)
          (remove-excluded-contacts ctx campaign)
          (remove-sent ctx campaign))]

    (shuffle
      (reduce
        (fn [userids c]
          (let [{:keys [memberset-postfn]} (get constraintdefs (:constrainttype c))]
            (if memberset-postfn
              (memberset-postfn ctx c userids)
              userids)))
        userid-set
        constraints))))